// /workflow-instance/{workflowInstanceId}/step/{workflowStepInstanceId}/additional-information/{workflowStepInstanceAdditionalInformationId}/review
import { dynamicApiSlice } from "@/app/dynamicApi";

// /workflow-instance/{workflowInstanceId}/step/{workflowStepInstanceId}/proceed-with-additional-information

export const workflowStepInstanceAdditionalInformationApi =
  dynamicApiSlice.injectEndpoints({
    endpoints: (builder) => ({
      updateAdditionalInformation: builder.mutation<
        unknown,
        {
          workflowInstanceId: string;
          workflowStepInstanceId: string;
          workflowStepInstanceOutputId: string;
          userInput: string;
          isRequired: boolean | null;
          attachments?: string[]; // Array of file IDs
        }
      >({
        query: ({
          workflowInstanceId,
          workflowStepInstanceId,
          workflowStepInstanceOutputId,
          userInput,
          isRequired,
          attachments = [],
        }) => ({
          url: `workflow-instance/${workflowInstanceId}/step/${workflowStepInstanceId}/additional-information/${workflowStepInstanceOutputId}/review`,
          method: "PUT",
          body: {
            userInput,
            isRequired,
            attachments,
          },
        }),
        invalidatesTags: (_result, _error, { workflowInstanceId }) => [
          { type: "WorkflowInstance", id: workflowInstanceId },
          { type: "WorkflowInstance", id: workflowInstanceId.toLowerCase() },
        ],
      }),
    }),
  });

export const { useUpdateAdditionalInformationMutation } =
  workflowStepInstanceAdditionalInformationApi;
